import {makeStyles, TextField} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import MaskedInput, {conformToMask} from 'react-text-mask';

//const Flag = require('react-world-flags').default;

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  countryCode: {
    width: 100,
    marginRight: theme.spacing(2),
    textAlign: 'center',
    flexGrow: 1,
  },
  phoneInput: {
    flexGrow: 9
  }
}));

const TextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={phoneMask}
      placeholderChar={'\u2000'}
      showMask
      onFocus={(event) => event.target.select()}
    />
  );
};

const PhoneInput = (props: any) => {
  const { value, onChange, ...rest } = props;
  const classes = useStyles();

  return (
    <TextField
      {...rest}
      //@ts-ignore
      className={classes.phoneInput}
      InputProps={{
        inputComponent: TextMaskCustom,
        value,
        onChange,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export const InternationalPhoneInput = (props: any) => {
    const {codeValue, onCodeChange, className, ...rest} = props;
    const {disabled} = props;
    const classes = useStyles();
    //const variant = rest['variant'] ? rest['variant'] : 'outlined';

    return (
        <div className={clsx(classes.root, className)}>
            <TextField
                className={classes.countryCode}
                label="Code"
                name={props.name + '_code'}
                onChange={onCodeChange}
                select
                // eslint-disable-next-line react/jsx-sort-props
                SelectProps={{native: true, displayEmpty: true}}
                value={codeValue}
                InputLabelProps={{
                    shrink: true,
                }}
                disabled={disabled}
                variant={props.variant}
                placeholder="Code"
            >
                <option value={'+1'}>+1</option>
                <option value={'+52'}>+52</option>
                <option value={'+44'}>+44</option>
                <option value={'+504'}>+504</option>
                <option value={'+61'}>+61</option>
                <option value={'+966'}>+966</option>
                <option value={'+55'}>+55</option>
                <option value={'+91'}>+91</option>
                <option value={'+27'}>+27</option>
                <option value={'+230'}>+230</option>
                <option value={'+264'}>+264</option>
            </TextField>
            <PhoneInput {...rest} />
        </div>
    );
};

export const cleanCellphone = (cellphone: string) => cellphone? cellphone.replace(/[\s\-\(\)]/g, '') : cellphone;

export const formatCellphone = (cellphone: string) => cellphone? conformToMask(cellphone, phoneMask, {}).conformedValue : cellphone;

export default PhoneInput;
